import React from 'react';
import {Form, Row} from 'react-bootstrap';

interface BrandAccessRightsFilterProps {
    handleChanges: React.ChangeEventHandler<HTMLInputElement>;

}

function BrandAccessRightsFilter({handleChanges}: BrandAccessRightsFilterProps) {
    return (
        <Form>
            <Row>
                <div className="col-md-4 col-6 mt-4">
                    <Form.Control
                        placeholder="Search by name"
                        className="autocomplete-input"
                        name="search"
                        onChange={handleChanges}
                    />
                </div>
            </Row>
        </Form>
    );
}

export default React.memo(BrandAccessRightsFilter);